var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { MULTI_FILE_NOTIFICATION_NAME } from './job';
export var FileNotificationMessageType;
(function (FileNotificationMessageType) {
    FileNotificationMessageType["ERROR"] = "ERROR";
    FileNotificationMessageType["WARNING"] = "WARNING";
    FileNotificationMessageType["SUCCESS"] = "SUCCESS";
})(FileNotificationMessageType || (FileNotificationMessageType = {}));
var UploadNotificationProvider = /** @class */ (function (_super) {
    __extends(UploadNotificationProvider, _super);
    function UploadNotificationProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return an object containing a summary for the specified jobNotifications
     */
    UploadNotificationProvider.prototype.getUploadNotificationStats = function (jobNotifications) {
        var stats = {
            numberOfFilesUploaded: 0,
            numberOfFilesFailedToUpload: 0,
            areWarningsPresent: false
        };
        var mergedUploadNotifications = this.getMergedUploadNotifications(jobNotifications);
        for (var _i = 0, mergedUploadNotifications_1 = mergedUploadNotifications; _i < mergedUploadNotifications_1.length; _i++) {
            var notification = mergedUploadNotifications_1[_i];
            if (notification.filename == MULTI_FILE_NOTIFICATION_NAME) {
                if (!notification.success) {
                    stats.areWarningsPresent = true;
                }
            }
            else {
                if (notification.success) {
                    stats.numberOfFilesUploaded++;
                }
                else {
                    stats.numberOfFilesFailedToUpload++;
                }
                if (notification.hasWarnings) {
                    stats.areWarningsPresent = true;
                }
            }
        }
        return stats;
    };
    /**
     * Accepts an array of JobNotifications, each containing a message for a specific upload filename.
     * Convert each JobNotification to an UploadNotification. For each unique filename, merges later
     * notifications with earlier notifications. Return an array of unique filenames and the combined
     * upload messages for each
     */
    UploadNotificationProvider.prototype.getMergedUploadNotifications = function (jobNotifications) {
        var uploadNotifications = this.parseUploadNotifications(jobNotifications);
        var notificationMap = {};
        for (var _i = 0, uploadNotifications_1 = uploadNotifications; _i < uploadNotifications_1.length; _i++) {
            var uploadNotification = uploadNotifications_1[_i];
            var fileKey = uploadNotification.filename;
            if (notificationMap[fileKey]) {
                notificationMap[fileKey] = this.mergeUploadNotifications(notificationMap[fileKey], uploadNotification);
            }
            else {
                notificationMap[fileKey] = uploadNotification;
            }
        }
        return Object.getOwnPropertyNames(notificationMap).map(function (fileKey) { return notificationMap[fileKey]; });
    };
    /**
     * Combine property values from the specified laterNotification with properties of the specified
     * formerNotification and return the resulting merged UploadNotification.
     */
    UploadNotificationProvider.prototype.mergeUploadNotifications = function (formerNotification, laterNotification) {
        if (laterNotification.filename != formerNotification.filename) {
            throw new Error("Cannot merge upload notification with filename = " + laterNotification.filename + " with notification with filename = " + formerNotification.filename + ". filename property must be the same for both notifications being merged");
        }
        return {
            filename: laterNotification.filename,
            message: this.mergeUploadNotificationMessages(formerNotification.message, laterNotification.message),
            // Latest success status always overrides earlier statuses
            success: laterNotification.success,
            // Set warning flag to indicate warning messages that need to be displayed
            // to the user
            hasWarnings: !formerNotification.success
        };
    };
    /**
     * Append the specified upload laterMessage string to the specified formerMessage
     */
    UploadNotificationProvider.prototype.mergeUploadNotificationMessages = function (formerMessage, laterMessage) {
        return "" + formerMessage + laterMessage + " <br />";
    };
    /**
     * Return an array of upload specific job notifications parsed
     * from the specified job notifications
     */
    UploadNotificationProvider.prototype.parseUploadNotifications = function (jobNotifications) {
        var uploadNotifications = [];
        for (var _i = 0, jobNotifications_1 = jobNotifications; _i < jobNotifications_1.length; _i++) {
            var notification = jobNotifications_1[_i];
            var uploadNotification = this.convertToUploadNotification(notification);
            if (uploadNotification) {
                uploadNotifications.push(uploadNotification);
            }
        }
        return uploadNotifications;
    };
    /**
     * Get an upload specific job notification, including details
     * about the success of the uploaded file and reason for any
     * individual file failure. Return null if an unexpected message
     * format is encountered
     */
    UploadNotificationProvider.prototype.convertToUploadNotification = function (jobNotification) {
        // The notification.message string is formatted as follows:
        // [non-json file name] {Back end file notification (json)}
        var filePartRegex = /^[^\{\}]+(?=\s\{)/g;
        var match = jobNotification.message.match(filePartRegex);
        if (!match || !match.length) {
            return null;
        }
        var filePart = match[0];
        var fileNotificationJsonPart = jobNotification.message.replace(filePartRegex, '');
        var fileNotification = this.parseFileNotification(fileNotificationJsonPart);
        if (fileNotification && fileNotification.messages) {
            var message = '';
            for (var _i = 0, _a = fileNotification.messages; _i < _a.length; _i++) {
                var subMessage = _a[_i];
                message = this.mergeUploadNotificationMessages(message, subMessage.message);
            }
            if (fileNotification.hasMoreMessages) {
                message += '...\n';
            }
            var uploadNotification = {
                filename: filePart,
                message: message,
                success: jobNotification.success
            };
            if (fileNotification.messages[0].errorCode) {
                uploadNotification.errorCode = fileNotification.messages[0].errorCode;
            }
            return uploadNotification;
        }
        else {
            return {
                filename: filePart,
                message: jobNotification.message,
                success: jobNotification.success
            };
        }
    };
    /**
     * Parse a FileNotification from a json string
     */
    UploadNotificationProvider.prototype.parseFileNotification = function (fileNotificationJson) {
        try {
            return JSON.parse(fileNotificationJson);
        }
        catch (err) {
            console.log('Failed to parse file detail as json. Treating as a string message instead');
            return null;
        }
    };
    UploadNotificationProvider = __decorate([
        Injectable()
    ], UploadNotificationProvider);
    return UploadNotificationProvider;
}(BaseProvider));
export { UploadNotificationProvider };
//# sourceMappingURL=upload-notification.js.map


// WEBPACK FOOTER //
// ./src/providers/upload-notification.ts.pre-build-optimizer.js